export const PROPOSALS_LIST = [
    {
        title: 'Texas Hold ’em Poker (Nevada Ruleset)',
        owner_address: '0xfab5b234b8a92823c73ee01a',
        submitted_date: '2020/11/04',
        votes: 46231,
        percentage_completed: 63,
        deployed_url: 'https://texas-holdem.iconbet.io'
    },
    {
        title: 'Texas Hold ’em Poker (Nevada Ruleset)',
        owner_address: '0xfab5b234b8a92823c73ee01a',
        submitted_date: '2020/11/04',
        votes: 46231,
        percentage_completed: 63,
        deployed_url: 'https://texas-holdem.iconbet.io'
    },
    {
        title: 'Texas Hold ’em Poker (Nevada Ruleset)',
        owner_address: '0xfab5b234b8a92823c73ee01a',
        submitted_date: '2020/11/04',
        votes: 46231,
        percentage_completed: 63,
        deployed_url: 'https://texas-holdem.iconbet.io'
    },
    {
        title: 'Texas Hold ’em Poker (Nevada Ruleset)',
        owner_address: '0xfab5b234b8a92823c73ee01a',
        submitted_date: '2020/11/04',
        votes: 46231,
        percentage_completed: 63,
        deployed_url: 'https://texas-holdem.iconbet.io'
    },
]

export const PROPOSAL_DETAIL = {
    title: 'Texas Hold ’em Poker (Nevada Ruleset)',
    owner_address: '0xfab5b234b8a92823c73ee01a',
    submitted_date: '2020/11/04',
    github_url:'https://github.com/iconbet-th-poker',
    votes: 46231,
    percentage_completed: 63,
    deployed_url: 'https://texas-holdem.iconbet.io',
    description:'Ut nec turpis ut purus eleifend congue at eget mauris. Suspendisse potenti. Vivamus faucibus fermentum quam, ac dignissim libero sollicitudin eu. Nunc congue nibh odio, id pulvinar dolor laoreet sit amet. Interdum et malesuada fames ac ante ipsum primis in faucibus. Nullam rhoncus lorem id neque pellentesque vehicula. Pellentesque malesuada mollis sem a rutrum. Duis viverra quam eros, ac molestie mi suscipit vel. Mauris luctus magna at lacinia luctus. Maecenas tristique sem vitae imperdiet ultricies. Pellentesque dapibus tempor mi, at maximus eros finibus at.'
}

export const VOTES = [
    {
        address: '0x5b234b8a92823c73ee01abaa',
        vote: 'approved',
        timestamp: '2020/04/22  13:00 UTC'
    },
    {
        address: '0x5b234b8a92823c73ee01abaa',
        vote: 'approved',
        timestamp: '2020/04/22  13:00 UTC'
    },
    {
        address: '0x5b234b8a92823c73ee01abaa',
        vote: 'approved',
        timestamp: '2020/04/22  13:00 UTC'
    },{
        address: '0x5b234b8a92823c73ee01abaa',
        vote: 'rejected',
        timestamp: '2020/04/22  13:00 UTC'
    },
    {
        address: '0x5b234b8a92823c73ee01abaa',
        vote: 'rejected',
        timestamp: '2020/04/22  13:00 UTC'
    },
    {
        address: '0x5b234b8a92823c73ee01abaa',
        vote: 'approved',
        timestamp: '2020/04/22  13:00 UTC'
    },
    {
        address: '0x5b234b8a92823c73ee01abaa',
        vote: 'approved',
        timestamp: '2020/04/22  13:00 UTC'
    },

]